function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_947",
  "data-name": "Group 947",
  transform: "translate(-152 -26.389)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_946",
  "data-name": "Group 946"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_945",
  "data-name": "Group 945"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1761",
  "data-name": "Rectangle 1761",
  width: 41.235,
  height: 41.235,
  transform: "translate(152 26.389)",
  fill: "none"
}))));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1291",
  "data-name": "Group 1291",
  transform: "translate(1.582 1.978)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_502",
  "data-name": "Path 502",
  d: "M160.247,38.588l1.078,21.28a1.507,1.507,0,0,0,1.36,1.525h16.409a1.505,1.505,0,0,0,1.359-1.525l1.079-21.28Zm6.081,19a.76.76,0,0,1-1.52,0v-15.2a.76.76,0,0,1,1.52,0Zm5.322,0a.76.76,0,0,1-1.52,0v-15.2a.76.76,0,0,1,1.52,0Zm5.321,0a.76.76,0,1,1-1.52,0v-15.2a.76.76,0,1,1,1.52,0Z",
  transform: "translate(-152.198 -27.378)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_515",
  "data-name": "Path 515",
  d: "M181.334,33.037h-6.082v-1.9A1.14,1.14,0,0,0,174.112,30h-6.842a1.14,1.14,0,0,0-1.141,1.141v1.9h-6.081a1.521,1.521,0,0,0-1.52,1.521v1.52h24.325v-1.52A1.521,1.521,0,0,0,181.334,33.037Z",
  transform: "translate(-152 -26.389)"
}));
var SvgTrash2 = function SvgTrash2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_bin",
    "data-name": "Icons / bin",
    width: 41.235,
    height: 41.235,
    viewBox: "0 0 41.235 41.235",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash2.21905ffa.svg";
export { ForwardRef as ReactComponent };